import React, { useMemo, useEffect } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import Expandible from "../../../layout/HelperDataTable/Expandible";
import { dataTablaA2026 } from "../../../data/2026/dataTablaA";

const baseUrlPDF =
  "https://itetlax.org.mx/assets/pdf/transparencia/tablaA/";

const TablaATable = () => {
  useEffect(() => {
    document.title = "Tabla de Aplicabilidad de Obligaciones de Transparencia 2026";
  }, []);

  const data = useMemo(() => {
    return dataTablaA2026.map((item) => ({
      ...item,
      archivo:
        item.archivo ||
        item.pdf1 ||
        item.pdf ||
        "",
    }));
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "titulo",
        header: "Documento",
        size: 700,
      },
      {
        accessorKey: "archivo",
        header: "PDF",
        size: 80,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) =>
          row.original.archivo ? (
            <a
              href={`${baseUrlPDF}2026/${row.original.archivo}`}
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faFilePdf}
                className="btn btn-danger"
              />
            </a>
          ) : null,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,

    enableExpanding: false,
    enableExpandAll: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,

    enableSorting: true,
    enablePagination: true,

    initialState: {
      pagination: {
        pageSize: 10,
        pageIndex: 0,
      },
    },
  });

  return (
    <div className="margin-bottom-2">
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Tabla de Aplicabilidad", url: "/tablaA" },
          { label: "2026" },
        ]}
      />

      <TitlePages
        title="Transparencia"
        subTitle="Tabla de Aplicabilidad de Obligaciones de Transparencia 2026"
      />

      <Expandible />

      <MaterialReactTable table={table} />
    </div>
  );
};

export default TablaATable;